import { PlusOutlined } from "@ant-design/icons"
import { Button, Flex, Form, Space, Typography } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import React from "react"

import type {
  ProjectFormData,
  ProjectFormDataPhase
} from "../../project-form-data.ts"
import { Milestones } from "./Milestones/Milestones.tsx"
import { MilestonesProjectTypes } from "./MilestonesProjectTypes.tsx"

interface MilestonesSetupSectionProps {
  form: FormInstance<ProjectFormData>
}

export function MilestonesSetupSection({ form }: MilestonesSetupSectionProps) {
  const activeProjectTypeId = Form.useWatch(
    "activeProjectTypeId",
    form
  ) as string

  const onAddMilestone = () => {
    const current = form.getFieldValue("project_phases") || []
    const uid = crypto.randomUUID()

    form.setFieldValue("project_phases", [
      ...current,
      {
        id: `_${uid}`,
        name: "",
        order: current?.length || 0,
        budget: { budget: 0 },
        project_type: activeProjectTypeId,
        checklist_data: []
      } satisfies ProjectFormDataPhase
    ])
  }

  return (
    <Flex vertical gap={"small"} className={"w-full"}>
      <Flex justify={"space-between"} gap={"small"} align={"center"}>
        <Typography.Title level={4}>Milestones Setup</Typography.Title>
        <Space>
          {/*<Button icon={<UnorderedListOutlined />}>From Template</Button>*/}
          <Button
            disabled={!activeProjectTypeId}
            onClick={onAddMilestone}
            type="primary"
            icon={<PlusOutlined />}
          >
            Milestone
          </Button>
        </Space>
      </Flex>
      <Flex vertical className={"w-full"}>
        <MilestonesProjectTypes form={form} />
        <Milestones form={form} activeProjectTypeId={activeProjectTypeId} />
        <Button
          className={"mt-3"}
          type="dashed"
          icon={<PlusOutlined />}
          disabled={!activeProjectTypeId}
          onClick={onAddMilestone}
        >
          Milestone
        </Button>
      </Flex>
    </Flex>
  )
}
